import { Link, Tabs } from '@chakra-ui/react';
import type { ReactElement, ReactNode } from 'react';

type VTabsOption = {
  label: ReactNode;
  value: string;
  content: ReactNode;
  disabled?: boolean;
  href?: string;
};

type VTabsProps = Omit<Tabs.RootProps, 'children'> & {
  options?: VTabsOption[];
  indicator?: boolean;
};

const TabTrigger = ({ option }: { option: VTabsOption }): ReactElement => {
  if (!option.href) {
    return (
      <Tabs.Trigger value={option.value} disabled={option.disabled}>
        {option.label}
      </Tabs.Trigger>
    );
  }

  return (
    <Tabs.Trigger value={option.value} disabled={option.disabled} asChild>
      <Link unstyled href={option.href}>
        {option.label}
      </Link>
    </Tabs.Trigger>
  );
};

const VTabs = ({ options = [], indicator = false, ...props }: VTabsProps): ReactElement => (
  <Tabs.Root {...props}>
    <Tabs.List>
      {options.map((option) => (
        <TabTrigger key={option.value} option={option} />
      ))}

      {indicator && <Tabs.Indicator />}
    </Tabs.List>

    {options.map((option) => (
      <Tabs.Content key={option.value} value={option.value}>
        {option.content}
      </Tabs.Content>
    ))}
  </Tabs.Root>
);

export default VTabs;
export type { VTabsProps, VTabsOption };
